import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { Lista_Historial_Visitas, QR_Detalle_Dispositivo, QR_Detalle_Visita, QR_Detalle_Visita_Pais, QR_Detalle_Visita_Total, Reporte_x_Ciudad, Reporte_x_pais, Reporte_x_pais_Grafico } from 'src/app/models/QR';
import { QrService } from 'src/app/service/qr.service';
import { StorageService } from 'src/app/service/storage.service';
 
 


@Component({
  selector: 'app-reporte-detalle',
  templateUrl: './reporte-detalle.component.html',
  styleUrls: ['./reporte-detalle.component.css']
})
export class ReporteDetalleComponent {



  id_parameter: any;
  QR_List_visitas: QR_Detalle_Visita_Pais[] = [];
  QR_List_Dispositivo: QR_Detalle_Dispositivo[] = [];
  List_Historial_x_Pais: Lista_Historial_Visitas[] = [];
  List_Historial_x_EquipoMovil: Lista_Historial_Visitas[] = [];
  List_Reporte_Pais: Reporte_x_pais[] = [];
  List_Reporte_Pais_detalle_tabla: Reporte_x_pais[] = [];
  List_Reporte_x_pais_Grafico: Reporte_x_Ciudad[] = [];
  rangoInicio: string = '';
  rangoFin: string = '';
  filtrofecha: boolean = false;
  mostrarBoton: boolean = false;
  limaDefecto: boolean =false;
  //reporte 1

  Highcharts: typeof Highcharts = Highcharts;
  Highcharts2: typeof Highcharts = Highcharts;

  // Paleta de marca (rojo Claro + tonos neutros), compartida por los 3
  // gráficos para que se vean consistentes entre sí y con el Dashboard.
  private readonly paletaGrafico = ['#DA291C', '#F26A5B', '#F2A488', '#8C1A12', '#5F6368', '#91979E', '#C9CCD1', '#E7E7E7'];

  private opcionesBaseGrafico(): Highcharts.Options {
    return {
      chart: { type: 'pie' },
      title: { text: '' },
      colors: this.paletaGrafico,
      tooltip: {
        pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
      },
      plotOptions: {
        pie: {
          innerSize: '60%',
          borderWidth: 2,
          borderColor: '#FFFFFF',
          showInLegend: true,
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.0f}%',
            distance: -28,
            style: { fontWeight: 'bold', fontSize: '11px', textOutline: 'none', color: '#FFFFFF' },
            filter: { property: 'percentage', operator: '>', value: 4 }
          }
        }
      },
      legend: {
        enabled: true,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        itemStyle: { fontSize: '12px', fontWeight: 'normal' },
        maxHeight: 380
      },
      series: [{ data: [], type: 'pie' }]
    };
  }

  // Agrupa las categorías con menos visitas en "Otros" para que el
  // gráfico no se llene de etiquetas diminutas superpuestas.
  private agruparTopN(items: { name: string | undefined, y: number | undefined }[], maxSlices = 7) {
    const ordenado = [...items]
      .map(item => ({ name: item.name ?? '', y: item.y ?? 0 }))
      .sort((a, b) => b.y - a.y);

    const principales = ordenado.slice(0, maxSlices);
    const resto = ordenado.slice(maxSlices);
    const otrosTotal = resto.reduce((sum, item) => sum + item.y, 0);

    return otrosTotal > 0
      ? [...principales, { name: `Otros (${resto.length})`, y: otrosTotal }]
      : principales;
  }

  chartOptions: Highcharts.Options = this.opcionesBaseGrafico();

  //reporte 2
  chartOptions2: Highcharts.Options = this.opcionesBaseGrafico();

  //reporte 3
  chartOptions3: Highcharts.Options = this.opcionesBaseGrafico();



  url: string = "";
  nro_visitas: number | undefined;
  constructor(
    private toastr: ToastrService,
    private routeLink: Router,
    private route: ActivatedRoute,
    private modulesService: QrService,
    private storageService: StorageService,
    private routenavigate: Router,
    private http: HttpClient) { }
  ngOnInit(): void {
    const usuarioStorage = this.storageService.getUsuarioStorage();

    if (!usuarioStorage || Object.keys(usuarioStorage).length === 0) {

      this.routenavigate.navigate(['/login']);

    } else {
      this.id_parameter = this.route.snapshot.queryParamMap.get('id_query');
      this.cargarPantalla();
      this.cargarPantalla_Visita_x_Pais();
      this.cargarPantalla_Visita_x_Dispositivo();
      this.cargarPantalla_Visita_x_Pais_grafico(this.id_parameter);
      this.cargarPantalla_Visita_x_EquipoMovil_grafico(this.id_parameter);
      this.cargaListaCombo(this.id_parameter);
      this.filtrofecha = false;

    }




  }


  ConsultarFechas() {
    console.log('Fecha Inicioxx : ' + this.rangoInicio + '----Rango de FIN:' + this.rangoFin);
    if (this.rangoFin < this.rangoInicio) {
     
      this.toastr.info('ALERTA', 'La fecha de fin  es menor que la fecha de inicio');
    }
    else if(this.rangoInicio =="" || this.rangoFin =="" ){
      this.toastr.info('ALERTA', 'Debe ingresar la Fecha de Inicio y Fecha de Fin');
    }
    else {


      console.log('Fecha Inicio: ' + this.rangoInicio + '----Rango de FIN:' + this.rangoFin);
      this.id_parameter = this.route.snapshot.queryParamMap.get('id_query');
     
      this.List_Reporte_Pais = [];
      this.List_Reporte_Pais_detalle_tabla = [];
      this.QR_List_visitas= [];
      this.cargarPantalla_Fechas(this.rangoInicio, this.rangoFin);
      this.cargarPantalla_Visita_x_Pais_Fechas(this.rangoInicio, this.rangoFin);
      this.cargarPantalla_Visita_x_Dispositivo_Fechas(this.rangoInicio, this.rangoFin);
      this.cargarPantalla_Visita_x_Pais_grafico_Fechas(this.id_parameter, this.rangoInicio, this.rangoFin);
      this.cargarPantalla_Visita_x_EquipoMovil_grafico_Fechas(this.id_parameter, this.rangoInicio, this.rangoFin);
      this.cargaListaCombo_Fechas(this.id_parameter, this.rangoInicio, this.rangoFin);
      this.filtrofecha = true;

     
        this.mostrarBoton= true;
      
    }
  }

  datos: any[] = [
    { Nombre: 'Juan', Edad: 30, País: 'Perú' },
    { Nombre: 'María', Edad: 25, País: 'México' },
    { Nombre: 'Pedro', Edad: 35, País: 'Argentina' }
];

   

  //  QR_Detalle_Visita

  cargarPantalla() {
    this.modulesService.MuestraCantidadVisitasxID(this.id_parameter).subscribe(
      data => {
        console.log('resultado:' + JSON.stringify(data));
        this.nro_visitas = 0;
        this.nro_visitas = data[0].cantidad;
        this.url = data[0].url;
      }
    )
  }

  cargarPantalla_Fechas(fechaInicio: string, fechaFin: string) {
    this.modulesService.MuestraCantidadVisitasxID_Fechas(this.id_parameter, fechaInicio, fechaFin).subscribe(
      data => {
        console.log('resultado:' + JSON.stringify(data));
        this.nro_visitas = 0;
        this.nro_visitas = data[0].cantidad;
        this.url = data[0].url;
      }
    )
  }


  async cargaListaCombo(id: number) {
   this.limaDefecto= false;
    const reporte_pais: Reporte_x_pais[] = await this.modulesService.Lista_Reporte_x_Pais_combo(id);
    this.List_Reporte_Pais = reporte_pais;
    
    this.List_Reporte_Pais.forEach(element => {

      if(element.city == "Lima"){


        this.limaDefecto=true;
      //sin filtro de fecha
      this.modulesService.Lista_Reporte_x_Provincia("Lima", this.id_parameter).subscribe(
        data => {
          this.List_Reporte_Pais_detalle_tabla = data;
          
        }
      )


      this.modulesService.Lista_Reporte_x_Ciudad_Grafico("Lima", this.id_parameter).subscribe(
        data => {
          this.List_Reporte_x_pais_Grafico = data;
          // console.log('DATA PRIMER REPORTE: ' + JSON.stringify(data));
          this.updateChartOptions1();
        }
      )
      }
    });

    
  }




  async cargaListaCombo_Fechas(id: number, fechaInicio: string, fechaFin: string) {

    const reporte_pais: Reporte_x_pais[] = await this.modulesService.Lista_Reporte_x_Pais_combo_Fechas(id, fechaInicio, fechaFin);
    this.List_Reporte_Pais = reporte_pais;
    console.log('.salida:.>>' + + JSON.stringify(this.List_Reporte_Pais));
  }

  cargarPantalla_Visita_x_Pais() {
    this.modulesService.MuestraCantidadVisitasxPaisID(this.id_parameter).subscribe(
      data => {
        this.QR_List_visitas = data;
      }
    )
  }

  cargarPantalla_Visita_x_Pais_Fechas(fechaInicio: string, fechaFin: string) {
    this.modulesService.MuestraCantidadVisitasxPaisID_Fechas(this.id_parameter, fechaInicio, fechaFin).subscribe(
      data => {
        this.QR_List_visitas = data;
      }
    )
  }


  cargarPantalla_Visita_x_Dispositivo() {
    this.modulesService.MuestraCantidadVisitasxDispositivoID(this.id_parameter).subscribe(
      data => {
        this.QR_List_Dispositivo = data;
      }
    )
  }


  cargarPantalla_Visita_x_Dispositivo_Fechas(fechaInicio: string, fechaFin: string) {
    this.modulesService.MuestraCantidadVisitasxDispositivoID_Fechas(this.id_parameter, fechaInicio, fechaFin).subscribe(
      data => {
        this.QR_List_Dispositivo = data;
      }
    )
  }

  // options
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';

  onSelect(data: any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data: any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data: any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  async cargarPantalla_Visita_x_Pais_grafico(id: number) {
    try {
      const data = await new Promise((resolve, reject) => {
        this.modulesService.Lista_Reporte(id, 2).subscribe(
          data => {

            this.List_Historial_x_Pais = data;

            this.updateChartOptions2();
          },
          error => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async cargarPantalla_Visita_x_Pais_grafico_Fechas(id: number, fechaInicio: string, fechaFin: string) {
    try {
      const data = await new Promise((resolve, reject) => {
        this.modulesService.Lista_Reporte_Fechas(id, 2, fechaInicio, fechaFin).subscribe(
          data => {

            this.List_Historial_x_Pais = data;

            this.updateChartOptions2();
          },
          error => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }



  async cargarPantalla_Visita_x_EquipoMovil_grafico(id: number) {
    try {
      const data = await new Promise((resolve, reject) => {
        this.modulesService.Lista_Reporte(id, 3).subscribe(
          data => {
            console.log('DATA:' + JSON.stringify(data));
            this.List_Historial_x_EquipoMovil = data;
            //  resolve(data);
            this.updateChartOptions3();
          },
          error => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }


  async cargarPantalla_Visita_x_EquipoMovil_grafico_Fechas(id: number, fechaInicio: string, fechaFin: string) {
    try {
      const data = await new Promise((resolve, reject) => {
        this.modulesService.Lista_Reporte_Fechas(id, 3, fechaInicio, fechaFin).subscribe(
          data => {
            console.log('DATA:' + JSON.stringify(data));
            this.List_Historial_x_EquipoMovil = data;
            //  resolve(data);
            this.updateChartOptions3();
          },
          error => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }


  cargaLista_Tabla_Combos(event: Event) {
    this.limaDefecto= false;
    const selectElement = event.target as HTMLSelectElement;
    const selectedCountry = selectElement.value;

    if (this.filtrofecha) {
      console.log('Filtro 1');
      console.log('Fecha Inicio: ' + this.rangoInicio + '----Rango de FIN:' + this.rangoFin);


      this.modulesService.Lista_Reporte_x_Provincia_Fecha(selectedCountry, this.id_parameter, this.rangoInicio, this.rangoFin).subscribe(
        data => {
          this.List_Reporte_Pais_detalle_tabla = data;
          console.log('salida datos:' + JSON.stringify(data));
        }
      )


      this.modulesService.Lista_Reporte_x_Ciudad_Grafico_Fecha(selectedCountry, this.id_parameter, this.rangoInicio, this.rangoFin).subscribe(
        data => {
          this.List_Reporte_x_pais_Grafico = data;
          // console.log('DATA PRIMER REPORTE: ' + JSON.stringify(data));
          this.updateChartOptions1();
        }
      )


    } else {
      console.log('Filtro 2');

      //sin filtro de fecha
      this.modulesService.Lista_Reporte_x_Provincia(selectedCountry, this.id_parameter).subscribe(
        data => {
          this.List_Reporte_Pais_detalle_tabla = data;
          console.log('salida datos:' + JSON.stringify(data));
        }
      )


      this.modulesService.Lista_Reporte_x_Ciudad_Grafico(selectedCountry, this.id_parameter).subscribe(
        data => {
          this.List_Reporte_x_pais_Grafico = data;
          // console.log('DATA PRIMER REPORTE: ' + JSON.stringify(data));
          this.updateChartOptions1();
        }
      )
    }




  }

  volver() {
    this.routenavigate.navigate(['/principal/reportes']);
  }

  cargaPantallaDetale_x_Pais(valor: QR_Detalle_Visita_Pais) {
    console.log('Ingreso a la funcion');
    this.routeLink.navigate(['/principal/reportes_detalle_pais'],
      { queryParams: { id: valor.id_qr, pais: valor.country } });
  }


  updateChartOptions1() {
    const data = this.agruparTopN(this.List_Reporte_x_pais_Grafico.map(item => ({ name: item.distrito, y: item.value })));

    // Actualiza las opciones del gráfico con los nuevos datos
    this.chartOptions.series = [{
      type: 'pie',
      data: data,
    }];

    // Renderiza el gráfico con las nuevas opciones
    Highcharts.chart('container1', this.chartOptions);
  }


  updateChartOptions2() {
    const data = this.agruparTopN(this.List_Historial_x_Pais.map(item => ({ name: item.name, y: item.value })));

    // Actualiza las opciones del gráfico con los nuevos datos
    this.chartOptions2.series = [{
      type: 'pie',
      data: data,
    }];

    // Renderiza el gráfico con las nuevas opciones
    Highcharts.chart('container2', this.chartOptions2);
  }


  updateChartOptions3() {
    const data = this.agruparTopN(this.List_Historial_x_EquipoMovil.map(item => ({ name: item.name, y: item.value })));

    // Actualiza las opciones del gráfico con los nuevos datos
    this.chartOptions3.series = [{
      type: 'pie',
      data: data,
    }];

    // Renderiza el gráfico con las nuevas opciones
    Highcharts.chart('container3', this.chartOptions3);
  }


DescargarExcel(){ 
  this.modulesService.Reporte_Excel_Service(this.id_parameter, this.rangoInicio, this.rangoFin).subscribe(
    data => {
     if(data!=null){
//      this.fileDownloadService.downloadFile(fileUrl, fileName);
      //this.downloadFile("http://qr.claromarketingcloud.pe/Descarga/Reporte_20250212.xlsx","Reporte_20250212.xlsx");3

     //"http://qr.claromarketingcloud.pe/Descarga/Reporte_"+year+month+day+".xlsx";
       // window.open(data.mensaje, '_blank');
   
   console.log('Data Salida:' + JSON.stringify(data));
     window.location.href = data.mensaje;


     }else{
      console.log('error;');
     }
      
    }
  )
  
}





downloadFile(url: string, fileName: string): void {
  this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }, error => {
    console.error('Error descargando el archivo:', error);
  });
}

}
 

